import React, {useMemo, useEffect, useState} from "react";
import {Container, Grid, Tab, Tabs} from "@mui/material";


import {
    Vertical as ReportVertical,
    Category as ReportCategory,
    View as ReportView,
} from "../../models/sso.js";

import {useSelector} from "react-redux";
import {
    HOME, RETAIL, TABS, ORGANIZATION_ID_COOKIE
} from "./constants.js";

import "./style.scss";
import {getCookie, Client} from "weed-js";
import {useParams, useSearchParams} from "react-router-dom";
import Retail from "./verticals/retail/Retail";

export const Analytics = ({subscriptions, subscriptionItems, subscriptionProducts}) => {

    useEffect(() => {
        console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Rendering <Analytics> from scratch");
    }, []);

    const client = new Client();

    const [searchParams, setSearchParams] = useSearchParams();
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);
    const currentUser = useSelector(state => state.userReducer.loggedInUser.user);
    const organizationUsers = useSelector(state => state.userReducer.loggedInUser.organizationUsers);
    const organizationOptions = organizations.map((org) => {
        return {"label": org.name, "value": org.id};
    });
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const [verticals, setVerticals] = useState([]);
    const [categories, setCategories] = useState([]);
    const [availableViews, setAvailableViews] = useState([]);

    const whichTab = searchParams.get("tab") || TABS[HOME];
    const whichSubTab = searchParams.get("subtab") || null;

    const [selectedTab, setSelectedTab] = useState(whichTab ? parseInt(whichTab) : TABS[HOME]);
    const [selectedSubTab, setSelectedSubTab] = useState(whichSubTab ? parseInt(whichSubTab) : null);

    useEffect(() => {
        if (!selectedOrganization?.id) {
            return;
        }
        const abortController = new AbortController();
        Promise.all([
            ReportView.fetch({client, params: {organization_id: selectedOrganization?.id}, abortController}),
            ReportVertical.fetch({client, params: {}, abortController}),
            ReportCategory.fetch({client, params: {}, abortController})
        ]).then(([fetchedViews, fetchedVerticals, fetchedCategories]) => {
            setAvailableViews(fetchedViews);
            setVerticals(fetchedVerticals);
            setCategories(fetchedCategories);
        }).catch((error) => {
            if (error.code === "ERR_CANCELED") {
                return;
            }
            console.error(error);
        });
        return () => abortController.abort();
    }, [selectedOrganization]);

    const TabPanel = ({children, index}) => {
        if(index === selectedTab) {
            return <>{children}</>;
        }
        return "";
    };

    const selectTab = (event, newValue) => {
        setSelectedTab(newValue);
        setSearchParams(prev => {
            const p = new URLSearchParams(prev);
            p.set("tab", String(newValue));
            return p;
        });
    };

    return (<Container className={"workspace dashboard"} id="analytics-main">
        <Grid container spacing={12}>
            <Grid item xs={12} className={"report-body"}>
                <Tabs value={selectedTab} onChange={selectTab}>
                    <Tab label={HOME} value={TABS[HOME]} tabIndex={TABS[HOME]} id={"home-analytics-tab"}/>
                    <Tab label={RETAIL} value={TABS[RETAIL]} tabIndex={TABS[RETAIL]} id={"retail-analytics-tab"}/>
                </Tabs>
                <TabPanel index={TABS[HOME]} tag={selectedSubTab}>
                    <div className="analytics-home">
                        <h1>Welcome to your analytics dashboard.</h1>
                        <p>We currently only support dutchie for our online platform. We offer comprehensive Metrc reporting through our team of analysts. Email matt@canold.com for details.</p>
                        <p>Choose an organization, integration, and location at the bottom of your screen and then pop on over to the other tabs to gain valuable insights into your operation.</p>
                    </div>
                </TabPanel>
                <TabPanel index={TABS[RETAIL]} tag={selectedSubTab}>
                    <Retail client={client} selectedOrganization={selectedOrganization} tab={selectedSubTab} verticals={verticals} categories={categories} availableViews={availableViews} setAvailableViews={setAvailableViews}/>
                </TabPanel>
            </Grid>
        </Grid>
    </Container>);
};

export default Analytics;